import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { Logo } from 'components';

function LogoLink({ to = '' }) {
  return (
    <div>
      <NavLink to={to}>
        <Logo />
      </NavLink>
    </div>
  );
}

LogoLink.propTypes = {
  to: PropTypes.string,
};

export default LogoLink;
